import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DeclineAccessRequestMutationVariables = Types.Exact<{
  input: Types.DeclineAccessRequestInput;
}>;


export type DeclineAccessRequestMutation = { __typename?: 'Mutation', declineAccessRequest?: { __typename?: 'AccessRequestPayload', accessRequest?: { __typename?: 'AccessRequest', id?: string | null } | null } | null };


export const DeclineAccessRequest = /*#__PURE__*/ gql`
    mutation DeclineAccessRequest($input: DeclineAccessRequestInput!) {
  declineAccessRequest(input: $input) {
    accessRequest {
      id
    }
  }
}
    ` as unknown as DocumentNode<DeclineAccessRequestMutation, DeclineAccessRequestMutationVariables>;

          

          export const useDeclineAccessRequestMutation = (options?:MutationHookOptions<DeclineAccessRequestMutation, DeclineAccessRequestMutationVariables>) => useMutation(DeclineAccessRequest, options);
          

          export type DeclineAccessRequestMutationOptions = MutationHookOptions<DeclineAccessRequestMutation, DeclineAccessRequestMutationVariables>;

          

          export type DeclineAccessRequestMutationResult = ReturnType<typeof useDeclineAccessRequestMutation>[1];

          
